/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export { getCLS } from './getCLS.js';
export { getFCP } from './getFCP.js';
export { getFID } from './getFID.js';
export { getLCP } from './getLCP.js';
export { getTTFB } from './getTTFB.js';
export { getFP } from './getFP.js';
export { getNavigationTiming } from './getNavigationTiming.js';
// export { getTBT } from './getTBT.js';
// export * from './types.js';
export { getTTI } from './getTTI.js';
import { getFP } from './getFP.js';
import { getCLS } from './getCLS.js';
import { getFCP } from './getFCP.js';
import { getFID } from './getFID.js';
import { getLCP } from './getLCP.js';
import { getTTFB } from './getTTFB.js';
import { getNavigationTiming } from './getNavigationTiming.js';
// import { getTBT } from './getTBT.js';
import { getTTI } from './getTTI.js';
import { mix } from "../../../object.js";
class PerformanceConfig {
    clsEnable = true;
    fidEnable = true;
    lcpEnable = true;
    fcpEnable = true;
    ttfbEnable = true;
    fpEnable = true;
    navigation_timingEnable = true;
    // tbtEnable = true;
    ttiEnable = true;
}
const queue = new Set();
let master;
class RadarPerformance {
    option;
    constructor() {
        this.option = new PerformanceConfig;
    }
    init(_master, _option) {
        _master.util.log("RadarPerformance-master:", _master);
        _master.util.log("RadarPerformance-option:", _option);
        master = _master;
        this.option = _option;
        if (this.option.clsEnable)
            getCLS(this.addToQueue);
        if (this.option.fidEnable)
            getFID(this.addToQueue);
        if (this.option.lcpEnable)
            getLCP(this.addToQueue);
        if (this.option.fcpEnable)
            getFCP(this.addToQueue);
        if (this.option.ttfbEnable)
            getTTFB(this.addToQueue);
        if (this.option.fpEnable)
            getFP(this.addToQueue);
        if (this.option.navigation_timingEnable)
            getNavigationTiming(this.addToQueue);
        // if (this.option.tbtEnable) getTBT(this.addToQueue);
        if (this.option.ttiEnable)
            getTTI(this.addToQueue);
        //当页面后台或卸载时，报告所有可用的指标。
        addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'hidden') {
                this.flushQueue();
            }
        });
        //注意:Safari不会可靠地触发' visibilitychange '事件
        //页面正在被卸载。如果需要Safari支持，也应该刷新
        // pagehide事件中的队列。
        addEventListener('pagehide', this.flushQueue);
    }
    addToQueue(metric) {
        // console.log("addToQueue:", metric);
        queue.add(metric);
    }
    flushQueue() {
        if (queue.size > 0) {
            var that = this;
            queue.forEach(function (item) {
                var params = {
                    c: 'radar_performance',
                    _indicators: item.name,
                    _value: item.value,
                    isCustom: false,
                };
                if (item.params) {
                    params = mix(item.params, params, true);
                    // console.log("params:", params);
                }
                that.sendLog(params);
            });
            queue.clear();
        }
    }
    //发送事件
    sendLog(value) {
        if (master && Object.prototype.toString.call(master) === '[object Object]') {
            master.log(value, 'wpo');
        }
    }
}
export const performance = new RadarPerformance();
if (window.RADAR_MONITOR_WEBJSSDKPLUGIN && Object.prototype.toString.call(window.RADAR_MONITOR_WEBJSSDKPLUGIN) === '[object Object]') {
    window.RADAR_MONITOR_WEBJSSDKPLUGIN.performance = performance;
}
else {
    window.RADAR_MONITOR_WEBJSSDKPLUGIN = { performance: performance };
}
